import moment from 'moment';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import React from 'react';
import get from 'lodash/get';
import PromoValue from '../../main/settings/promoCodes/components/PromoValue';
import config from '../../../config';
import Icon, { GLYPHS } from '../../common/icon';

const AmountCell = ({ original }) => (
  <PromoValue promoCode={original} />
);
AmountCell.propTypes = {
  original: PropTypes.shape({
    type: PropTypes.number,
    amount: PropTypes.number,
  }).isRequired,
};

const ChexboxTableCell = ({ value }) => {
  if (!value) {
    return '–';
  }
  return <Icon size="small" glyph={GLYPHS.checkMark} />;
};
ChexboxTableCell.propTypes = {
  value: PropTypes.bool.isRequired,
};

const ExpirationCell = ({ value }) => {
  if (!value) {
    return '–';
  }
  return moment(value, config.dateFormatISO).format(config.dateFormat);
};

const CreatedAtCell = ({ value }) => {
  if (!value) {
    return '-';
  }
  return value;
};

const columns = [
  {
    Header: 'Promo name',
    accessor: 'code',
    className: 'u-type--uppercase',
  },
  {
    Header: 'Amount',
    accessor: 'value',
    width: 70,
    Cell: AmountCell,
  },
  {
    Header: 'New Clients',
    accessor: 'firstAppointmentOnly',
    className: 'u-text-center',
    width: 140,
    Cell: ChexboxTableCell,
  },
  {
    Header: 'One time promo',
    accessor: 'oneTime',
    Cell: ChexboxTableCell,
  },
  {
    Header: 'Expiration',
    accessor: 'expirationDate',
    width: 100,
    Cell: ExpirationCell,
  },
  {
    Header: 'createdAt',
    accessor: 'createdAt',
    Cell: CreatedAtCell,
    show: false,
  },
];
const SelectPromotion = ({ loading, promos, selectPromo, selected }) => (
  <div>
    <ReactTable
      className="c-select-promotion-table"
      loading={loading}
      data={promos}
      columns={columns}
      minRows="5"
      showPagination={false}
      pageSize={promos.length}
      sortable={false}
      resizable={false}
      defaultSorted={[
        {
          id: 'createdAt',
          desc: false,
        },
      ]}
      noDataText="No promos found"
      getTrProps={(state, rowInfo) => ({
        onClick: selectPromo(get(rowInfo, 'original.id')),
        className: 'is-active',
      })}
      getTrGroupProps={(state, rowInfo) => ({
        className: get(rowInfo, 'original.id') === selected ? 'is-active' : '',
      })}
    />
  </div>
);
SelectPromotion.propTypes = {
  loading: PropTypes.bool.isRequired,
  promos: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      value: PropTypes.number,
      type: PropTypes.number,
      firstAppointmentOnly: PropTypes.bool,
      expirationDate: PropTypes.string,
    }),
  ).isRequired,
  selectPromo: PropTypes.func.isRequired,
  selected: PropTypes.string,
};
SelectPromotion.defaultProps = {
  selected: null,
};

export default SelectPromotion;
